import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'kontakt'
  },
  {
    path: 'kontakt',
    pathMatch: 'full',
    loadComponent: () => import('./components/contact/contact.component').then(c => c.ContactComponent)
  },
  {
    path: 'reklamation',
    pathMatch: 'full',
    loadComponent: () => import('./components/reclaim/reclaim.component').then(c => c.ReclaimComponent)
  },
  { path: '**',
    loadComponent: () => import('./components/notfound/notfound.component').then(c => c.NotFoundComponent)
  }
];
